module.exports = __webpack_public_path__ + "fonts/Inter-500-latin56.260c81a.woff2";